import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';
import reducer from '../reducers';

const loggerMiddleware = createLogger();

export default function createAppStore(preloadedState) {
	return configureStore({
		reducer,
		preloadedState,
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware().concat(loggerMiddleware)
	});
}
